<template>
  <div id="message" v-if="error">
    <v-alert
      :value="error"
      type="error"
    >
    {{error_message}}
    </v-alert>      
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'Messages',
        computed:{
          ...mapGetters(['error', 'error_message'])
        },
        created(){
          setTimeout(() => {
            this.$store.commit('UNSET_ERROR')
          }, 4000)
        },
        updated(){
          setTimeout(() => {
            this.$store.commit('UNSET_ERROR')
          }, 4000)
        },
    }
</script>

<style lang="scss" scoped>
  #message{
    position: fixed;
    bottom: 0;
  }
</style>